var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg038Globe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 9.34784 20.9464 6.8043 19.0711 4.92893C17.1957 3.05357 14.6522 2 12 2ZM11 19.93C9.11571 19.6887 7.37877 18.7848 6.1 17.38C7.63669 16.643 9.29961 16.2052 11 16.09V19.93ZM11 14.07C8.88129 14.1952 6.81131 14.7569 4.92 15.72C3.70015 13.3935 3.70015 10.6165 4.92 8.29C6.80846 9.26965 8.87774 9.85164 11 10V14.07ZM11 7.93C9.29661 7.8065 7.63133 7.36559 6.09 6.63C7.36589 5.21441 9.10889 4.30563 11 4.07V7.93ZM13 4.07C14.8911 4.30563 16.6341 5.21441 17.91 6.63C16.3687 7.36559 14.7034 7.8065 13 7.93V4.07ZM13 19.93V16.09C14.7018 16.2039 16.3656 16.6453 17.9 17.39C16.6197 18.7911 14.8829 19.6914 13 19.93ZM20 12C19.9992 13.2962 19.6835 14.5728 19.08 15.72C17.1887 14.7569 15.1187 14.1952 13 14.07V10C15.1201 9.86097 17.1893 9.28923 19.08 8.32C19.6773 9.45517 19.9928 10.7173 20 12Z",
    fill: "#8199A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg038Globe);
export default __webpack_public_path__ + "static/media/038-globe.e3c5499e1eb96c7fb089d80ed8d87e66.svg";
export { ForwardRef as ReactComponent };